import { getAwsApiClient } from 'apiClient';
import { type AxiosRequestConfig } from 'axios';

type BodyRequest = Blob;

type UploadedChunkResponse = unknown;

export const uploadChunk = async ({
  body,
  config,
  url,
}: {
  body: BodyRequest;
  config: AxiosRequestConfig & {
    headers: {
      'x-amz-checksum-sha256': string;
    };
  };
  url: string;
}) => getAwsApiClient().put<UploadedChunkResponse>(url, body, config);
